import { ISiteSettingsForServerAdmin } from '../../../settings/types/ISite';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IGetSiteSettingsForServerAdminParams {
  id: string;
}

export type IGetSiteSettingsForServerAdminResult = IResult & ISiteSettingsForServerAdmin;

export class GetSiteSettingsForServerAdminRequest
  extends Request<IGetSiteSettingsForServerAdminParams, IGetSiteSettingsForServerAdminResult>
{
  constructor(params: IGetSiteSettingsForServerAdminParams) {
    super('getSiteSettingsForServerAdmin', params);
  }
}
